'use client';

import { ChipProps } from '@mui/material';

import { Typography } from '../Typography';

import { ChipStyled } from './styled';

export const Chip = (props: ChipProps) => {
  const { label, size, ...rest } = props;

  if (size === 'small') {
    return (
      <ChipStyled
        size={size}
        label={
          <Typography color={'inherit'} variant="body7">
            {label}
          </Typography>
        }
        {...rest}
      />
    );
  }

  return (
    <ChipStyled
      size={size}
      label={
        <Typography color={'inherit'} variant="body6">
          {label}
        </Typography>
      }
      {...rest}
    />
  );
};
